export default __webpack_public_path__ + "static/media/FC22F340-AFBF-40C3-A569-9830A4F831FE_1_105_c.bcf0d8d3.jpeg";